"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageContainer = exports.optionImage = void 0;

var _emotion = require("emotion");

var optionImage =
/*#__PURE__*/
(0, _emotion.css)("height:100%;width:inherit;border-radius:3px;");
exports.optionImage = optionImage;

var imageContainer = function imageContainer(heightWidth) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("border-radius:3px;width:", heightWidth, "px;height:", heightWidth, "px;margin-right:12px;")
  );
};

exports.imageContainer = imageContainer;